import React, { Component } from 'react';
import { Form } from 'antd';
import { connect } from '@souche-f2e/muji';
import { RowCol } from '@/components';
import styles from '../style/index.less';
import { jumpReport } from '@/shared/functions';
const mapStateToProps = (rootState) => ({
    carDetail: rootState.carDetail,
});
class DetailGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detail1: [
                {
                    label: '车型',
                    key: 'carModelName',
                },
                {
                    label: '车辆类型',
                    key: 'carType',
                },
                {
                    label: '车辆所在地',
                    key: 'locationName',
                },
                {
                    label: '车辆归属地',
                    key: 'registerName',
                },
                {
                    label: '出厂日期',
                    key: 'factoryDate',
                },
                {
                    label: '登记日期',
                    key: 'registerDate',
                },
                {
                    label: '表显里程(公里)',
                    key: 'mileage',
                },
                {
                    label: '检测报告',
                    key: 'reportUrl',
                },
            ],
            detail2: [
                {
                    label: '车牌号',
                    key: 'license',
                },
                {
                    label: 'VIN码',
                    key: 'vin',
                },
                {
                    label: '发动机号',
                    key: 'engine',
                },
                {
                    label: '保留价（元）',
                    key: 'basePriceYuan',
                },
                // {
                //   label: '收购价（元）',
                //   key: 'buyPriceYuan',
                // },
                {
                    label: '起拍价（元）',
                    key: 'auctionPriceYuan',
                },
            ],
            detail3: [
                {
                    label: '备注',
                    key: 'comment',
                },
            ],
        };
    }
    render() {
        const { detail1, detail2, detail3 } = this.state;
        const carDetails = this.props.carDetail;
        return (<React.Fragment>
        <Form labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} labelAlign={'left'}>
          <RowCol>
            {detail1.map((v, i) => {
            return (<Form.Item label={v.label} key={i} style={{
                marginBottom: '15px',
                lineHeight: '15px',
            }}>
                    {(v.key === 'factoryDate' || v.key === 'registerDate') && (<span>{carDetails[v.key].split(' ')[0] || '无'}</span>)}
                    {(v.key === 'reportUrl') && (carDetails[v.key] !== '' ? (<a onClick={() => {
                jumpReport(carDetails['reportUrl']);
            }}>
                            查看
                          </a>) : (<span>无</span>))}
                    {(v.key !== 'factoryDate' && v.key !== 'registerDate' && v.key !== 'reportUrl') && (<span>{carDetails[v.key] || '无'}</span>)}
                  </Form.Item>);
        })}
          </RowCol>
          <div className={styles.line}/>
          <RowCol>
            {detail2.map((v, i) => (<Form.Item label={v.label} key={i} style={{
            marginBottom: '15px',
        }}>
                  <span>{carDetails[v.key] || '无'}</span>
                </Form.Item>))}
          </RowCol>
          <div className={styles.line}/>
          <RowCol>
            {detail3.map((v, i) => (<Form.Item label={v.label} key={i} style={{
            marginBottom: '15px',
        }}>
                  <span>{carDetails[v.key] || '无'}</span>
                </Form.Item>))}
          </RowCol>
        </Form>
      </React.Fragment>);
    }
}
export default connect(mapStateToProps)(DetailGrid);
